document.addEventListener("DOMContentLoaded", function () {
  var isMobile = window.innerWidth <= 599;
  var swiper;

  function initSwiper() {
    swiper = new Swiper(".swiper", {
      slidesPerView: "auto",
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  function destroySwiper() {
    if (swiper) {
      swiper.destroy();
      swiper = undefined;
    }
  }

  function handleResize() {
    if (window.innerWidth <= 599) {
      if (!swiper) {
        initSwiper();
      }
    } else {
      destroySwiper();
    }
  }

  handleResize();

  window.addEventListener("resize", handleResize);

  var headerSwiper = new Swiper(".mySwiper", {
    keyboard: {
      enabled: true,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});
